import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import usePrevious from '../../hooks/use-previous';
import { LoopScrollTypes } from './types';

import styles from './rangepicker.module.css';

export default function InfiniteScrollLoop({
  surroundingBackup = 4,
  children,
  className = '',
  type,
  currentTime,
}: LoopScrollTypes): React.JSX.Element {
  const [height, setHeight] = useState<number>(0);
  const [positionAssigned, setPositionAssigned] = useState(false);

  const scrollRef = useRef<HTMLDivElement | null>(null);
  const contentRef = useRef<HTMLDivElement | null>(null);

  const backupHeight = height * surroundingBackup;

  const handleScroll = useCallback(() => {
    if (scrollRef?.current) {
      const scroll = scrollRef?.current?.scrollTop;
      if (scroll < backupHeight || scroll >= backupHeight + height) {
        scrollRef.current.scrollTop = backupHeight + (scroll % height);
      }
    }
  }, [height]);

  const prevCurrentTime = usePrevious(currentTime);

  useLayoutEffect(() => {
    if (contentRef?.current && scrollRef?.current) {
      setHeight(contentRef.current.offsetHeight);

      if (
        !positionAssigned ||
        (prevCurrentTime?.toString() && prevCurrentTime !== currentTime)
      ) {
        const currentNodes = scrollRef.current.querySelectorAll(
          `.${type}-button-${currentTime}`,
        );

        if (currentNodes?.length) {
          const currentNode = currentNodes[1];

          if (currentNode) {
            currentNode.scrollIntoView({
              block: 'center',
            });

            if (!positionAssigned) {
              setTimeout(() => {
                setPositionAssigned(true);
              }, 20);
            }
          }
        }
      }
    }
  });

  return (
    <div>
      <div
        className={className}
        style={{
          height,
        }}
        ref={scrollRef}
        onScroll={handleScroll}
      >
        {Array(surroundingBackup)
          // @ts-ignore
          .fill()
          .map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={styles.timeWrapper}>
              {children}
            </div>
          ))}
        <div ref={contentRef} className={styles.timeWrapper}>
          {children}
        </div>
        {Array(surroundingBackup)
          // @ts-ignore
          .fill()
          .map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={styles.timeWrapper}>
              {children}
            </div>
          ))}
      </div>
    </div>
  );
}
